<template>
  <div 
      class="custom-selector-white"
      @mouseover="openSelector"
      @mouseleave="closeSelector"
  >
    <div class="selected" 
      @click="showOptions = !showOptions"
      @mouseleave="closeSelector"
    >
      <div class="selected-container">
        <div class="selected-content">
          <div class="selected-col">
            <div class="selected-title" v-if="title != null" :class="{'invalid': !inputIsValid}">{{ title }}</div>
            <div class="selected-row">
              <div class="row-icon" v-if="selectedIcon != null"><img :src="selectedIcon" alt=""></div>
              <div class="row-label" :class="{'selected-placeholder': showPlaceholder}">{{ selectedLabel }}</div>
            </div>
          </div>
          <div class="row-r-icon"></div>
        </div>
        <div class="selected-icon" :class="{'selected-row-opened': showOptions}"></div>
      </div>
    </div>
    <div ref="optionsItemsDiv" class="items" v-show="showOptions">
      <div class="placeholder" v-if="placeholder != null">{{ placeholder }}</div>
      <div :id="'optionsDiv' + index" class="row" :class="{'active': index === selectedIndex}" v-for="(option, index) in options"
           v-bind:key="index"
           @click="optionSelected(index)">
        <div class="row-icon" v-if="option.icon != null"><img :src="option.icon" alt=""></div>
        <div class="row-label">{{ option.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */


import {ref, onMounted, watch, onUnmounted} from "@vue/runtime-core";
import {computed} from "@vue/reactivity";

export default {
  name: "CustomSelector",
  props: {
    'modelValue': Object,
    'title': String,
    'placeholder': String,
    'isValid': {
      type: Boolean,
      default: true
    },
    'options': {
      type: Object,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    let showPlaceholder = ref(false)
    let showOptions = ref(false)
    let selectedIcon = ref(null)
    let selectedIndex = ref(null)
    let optionsItemsDiv = ref(null)
    let optionsDiv = ref(null)

    let filter = ''

    const inputIsValid = computed(() => {
      if (typeof props.isValid === 'undefined')
        return true
      else {
        if (props.isValid)
          return true
        else
          return selectedIndex.value !== null
      }
    })

    const selectedLabel = computed(() => {
      showPlaceholder.value = false
      if (props.placeholder != null) {
        if (selectedIndex.value == null) {
          selectedIcon.value = null
          showPlaceholder.value = true
          return props.placeholder
        }
      }
      if (selectedIndex.value != null) {
        if ('icon' in props.options[selectedIndex.value]) {
          selectedIcon.value = props.options[selectedIndex.value].icon
        } else {
          selectedIcon.value = null
        }
        return props.options[selectedIndex.value].text
      }
      selectedIcon.value = null
      return null
    })

    const refreshValue = (() => {
      // console.log('refreshing...')
      // console.log(props.modelValue)
      //  TODO: avoid it iterating over all the array
      if (props.modelValue != null) {
        props.options.forEach((option, index) => {
          if (option.value === props.modelValue) {
            selectedIndex.value = index
          }
        })
      } else {
        selectedIndex.value = null
      }
      showOptions.value = false
    })

    watch(() => props.modelValue, (newValue) => {
      refreshValue()
    })

    watch(showOptions, () => {
      if (!showOptions.value) {
        filter = ''
      }
    })

    const optionSelected = ((index) => {
      showOptions.value = false
      selectedIndex.value = index
      emit("update:modelValue", props.options[selectedIndex.value].value)
    })

    const openSelector = () => {
      showOptions.value = true
    }

    const closeSelector = () => {
      showOptions.value = false
    }


    onMounted(() => {
      window.addEventListener('keypress', keyPressed)

      refreshValue()
    })

    onUnmounted(() => {
      window.removeEventListener('keypress', keyPressed)
    })

    const keyPressed = (e) => {
      if (showOptions.value) {
        filter += e.key.toLowerCase()
        // console.log(filter)
        let found = -1
        for (let index = 0; index < props.options.length; index++) {
          const option = props.options[index]
          if (option.text.toLowerCase().includes(filter)) {
            found = index
            break
          }
        }

        if (found >= 0) {
          const el = document.getElementById('optionsDiv' + found)
          // console.log(found)
          // console.log(el.offsetTop)
          // el.scrollIntoView(true)
          // optionsItemsDiv.value.scrollTop = el.scrollHeight
          // optionsItemsDiv.value.scrollTo(0, parseInt(found) * 16)
          optionsItemsDiv.value.scrollTo(0, el.offsetTop)
          // optionsItemsDiv.value.scrollIntoView()
        }
      }
    }

    onMounted(refreshValue)

    return {
      keyPressed,

      optionsItemsDiv,
      optionsDiv,

      inputIsValid,
      optionSelected,
      refreshValue,
      selectedLabel,

      showPlaceholder,
      showOptions,
      selectedIcon,
      selectedIndex,
      openSelector,
      closeSelector
    }
  },
}
</script>
